module.exports = __webpack_public_path__ + "static/media/ContactRight_CN.3cbf0eff.png";